import { isEqualValueIgnoreOrder } from "@ixfx/core";
import * as TreeMutable from './tree-mutable.js';
export const compare = (a, b, eq = isEqualValueIgnoreOrder, parent) => {
    const valueEqual = valueOrIdentityEqual(a, b, eq);
    // if (!valueEqual) {
    //   nsole.log(`changed compare a: ${ toStringSingle(a) } b: ${ toStringSingle(b) }`);
    // }
    const childrenCompare = compareChildren(a, b, eq);
    const diff = {
        valueChanged: !valueEqual, a, b,
        added: childrenCompare.added,
        removed: childrenCompare.removed,
        childChanged: false
    };
    const diffNode = {
        value: diff,
        childrenStore: [],
        parent
    };
    const childrenDiff = childrenCompare.identical.map(c => compare(c[0], c[1], eq, diffNode));
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const someChildChange = hasChange(diff) || childrenDiff.some(v => hasChange(v.value));
    TreeMutable.setChildren(diffNode, childrenDiff);
    //diffNode.childrenStore = childrenDiff;
    diffNode.toString = () => toString(diffNode, 0);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    diffNode.value.childChanged = someChildChange;
    TreeMutable.throwTreeTest(diffNode);
    return diffNode;
};
const hasChange = (vv) => {
    if (vv === undefined)
        return false;
    if (vv.valueChanged)
        return true;
    if (vv.childChanged)
        return true;
    if (vv.added.length > 0)
        return true;
    if (vv.removed.length > 0)
        return true;
    return false;
};
const compareChildren = (a, b, eq = isEqualValueIgnoreOrder) => {
    const childrenOfA = [...a.children()];
    const childrenOfB = [...b.children()];
    const identical = [];
    const removed = [];
    for (const childA of childrenOfA) {
        let foundIndex = -1;
        for (const [index, childOfB] of childrenOfB.entries()) {
            const d = valueOrIdentityEqual(childA, childOfB, eq);
            if (d) {
                identical.push([childA, childOfB]);
                foundIndex = index;
                break;
            }
        }
        if (foundIndex === -1) {
            // A's child not found in B's children
            removed.push(childA);
        }
        else {
            // Found, remove it from list of B's children
            childrenOfB.splice(foundIndex, 1);
        }
    }
    const added = [...childrenOfB];
    return { added, identical, removed };
};
const valueOrIdentityEqual = (a, b, eq) => {
    if (a.getIdentity() === b.getIdentity())
        return true;
    if (eq(a.getValue(), b.getValue()))
        return true;
    return false;
};
const toStringSingle = (n) => {
    return JSON.stringify(n.getValue());
};
const toString = (n, indent = 0) => {
    if (n === undefined)
        return `(undefined)`;
    let t = toStringDiff(n.value, indent);
    for (const c of n.childrenStore) {
        t += toString(c, indent + 2);
    }
    return t;
};
const toStringDiff = (n, indent) => {
    const spaces = ` `.repeat(indent);
    if (n === undefined)
        return `${spaces}(undefined)`;
    const t = [];
    t.push(`a: ${toStringSingle(n.a)} b: ${toStringSingle(n.b)}`);
    if (n.valueChanged)
        t.push(`Value changed. Child changed: ${n.childChanged}`);
    else
        t.push(`Value unchanged. Child changed: ${n.childChanged}`);
    if (n.added.length > 0) {
        t.push(`Added:`);
        for (const c of n.added) {
            t.push(` - ` + toStringSingle(c));
        }
    }
    if (n.removed.length > 0) {
        t.push(`Removed: ${n.removed.length}`);
        for (const c of n.removed) {
            t.push(` - ` + toStringSingle(c));
        }
    }
    t.push(`----\n`);
    return t.map(line => spaces + line).join(`\n`);
};
